export default "__VITE_ASSET__CzHucsjm__"